var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBrokerIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.5 6.66927V5.0026C2.5 4.56058 2.67559 4.13665 2.98816 3.82409C3.30072 3.51153 3.72464 3.33594 4.16667 3.33594H15.8333C16.2754 3.33594 16.6993 3.51153 17.0118 3.82409C17.3244 4.13665 17.5 4.56058 17.5 5.0026V6.66927M2.5 6.66927V11.6693M2.5 6.66927H7.5M17.5 6.66927V11.6693M17.5 6.66927H7.5M2.5 11.6693V15.0026C2.5 15.4446 2.67559 15.8686 2.98816 16.1811C3.30072 16.4937 3.72464 16.6693 4.16667 16.6693H7.5M2.5 11.6693H7.5M7.5 6.66927V11.6693M17.5 11.6693V15.0026C17.5 15.4446 17.3244 15.8686 17.0118 16.1811C16.6993 16.4937 16.2754 16.6693 15.8333 16.6693H7.5M17.5 11.6693H7.5M7.5 16.6693V11.6693M12.5 6.66927V16.6693",
    stroke: "#FCFCFC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrokerIcon);
export default __webpack_public_path__ + "static/media/brokerIcon.bad0b8577f6a2bc782d592f6c274a4c1.svg";
export { ForwardRef as ReactComponent };